var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { TimelineContainer } from './styles/timeline.styled';
/**
 * The Timeline component can be used to render a timeline
 */
export const Timeline = (_a) => {
    var { children, spacious = false, domProps } = _a, props = __rest(_a, ["children", "spacious", "domProps"]);
    return (React.createElement(TimelineContainer, Object.assign({ className: classNames('PONCHO-timeline', {
            'PONCHO-timeline__spacious': spacious,
        }), "$isSpacious": spacious }, domProps, props), children));
};
//# sourceMappingURL=Timeline.js.map